import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "stat_item-text" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "stat_item-icon",
  ref: "statIconDv"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_ctx.value > 0 || _ctx.allowZero)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["stat_item", {
      shadeTwo: _ctx.predefined || _ctx.colorFade,
      compact: _ctx.predefined,
      nonValue: _ctx.value == 0,
      selectedOutline: _ctx.stat.isSelected && _ctx.hideTick,
      isLink: ['followersCount', 'followingCount'].includes(_ctx.stat.key),
      disabled: _ctx.disabled,
    }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
      _ctx.handleClick({
        ..._ctx.stat,
        calcVal: _ctx.$filters.getStatsValue(_ctx.stat.key, _ctx.value ?? 0),
      })
    ), ["stop"])),
        style: _normalizeStyle({ borderColor: _ctx.color })
      }, [
        (_ctx.showRemove)
          ? (_openBlock(), _createBlock(_component_IconComponent, {
              key: 0,
              icon: "minus.svg",
              class: "topRightIcon c-pointer",
              onClick: _withModifiers(_ctx.onRemove, ["stop"]),
              onTouchstart: _ctx.onRemove
            }, null, 8, ["onClick", "onTouchstart"]))
          : _createCommentVNode("", true),
        (_ctx.showSelected && _ctx.stat.isSelected && !_ctx.hideTick)
          ? (_openBlock(), _createBlock(_component_IconComponent, {
              key: 1,
              class: "topRightIcon",
              icon: "icon-tick-info-dv-two.svg",
              noRtlTransform: ""
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.stat.label === 'Interests')
            ? (_openBlock(), _createElementBlock("h6", {
                key: 0,
                ref: "label"
              }, _toDisplayString(_ctx.$t("common.common.attributes")), 513))
            : (_ctx.stat.label === 'Favorite Investments')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.isOverflowing)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        class: "box-item",
                        effect: "dark",
                        content: 'Favorite Symbols',
                        placement: "top-start"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h6", { ref: "label" }, _toDisplayString(_ctx.$t("common.common.favorite_symbols")), 513)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("h6", {
                        key: 1,
                        ref: "label"
                      }, _toDisplayString(_ctx.$t("common.common.favorite_symbols")), 513))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.isOverflowing)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        class: "box-item",
                        effect: "dark",
                        content: _ctx.stat.label
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h6", { ref: "label" }, _toDisplayString(_ctx.$t(`profile.stats.${_ctx.stat.key}`)), 513)
                        ]),
                        _: 1
                      }, 8, ["content"]))
                    : (_openBlock(), _createElementBlock("h6", {
                        key: 1,
                        ref: "label"
                      }, _toDisplayString(_ctx.$t(`profile.stats.${_ctx.stat.key}`)), 513))
                ], 64)),
          (_ctx.stat.key === 'investments')
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                innerHTML: 
          _ctx.formatWithComma(
            _ctx.$filters.systemNumberConvention(
              _ctx.locale === 'ar' && _ctx.value % 1 !== 0 ? _ctx.value.toFixed(7) : _ctx.value,
              true,
              false,
              100
            )
          )
        
              }, null, 8, _hoisted_2))
            : (
          _ctx.stat.label === 'Avg TR/Month' || _ctx.stat.label === 'Avg TR/Week'
        )
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  innerHTML: _ctx.locale === 'ar' && _ctx.value % 1 !== 0 ? _ctx.value.toFixed(7) : _ctx.value
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("p", {
                  key: 5,
                  innerHTML: 
          _ctx.locale === 'ar' && _ctx.value % 1 !== 0
            ? _ctx.formatWithComma(_ctx.value.toFixed(7))
            : _ctx.formatWithComma(_ctx.value)
        
                }, null, 8, _hoisted_4))
        ]),
        (_ctx.icon && _ctx.showIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_IconComponent, {
                icon: _ctx.icon + '.svg',
                path: "/stats-icon",
                noRtlTransform: ""
              }, null, 8, ["icon"])
            ], 512))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}